export const EXPORT_STATISTICS_GROUPS = 'EXPORT_STATISTICS_GROUPS';
export const LOAD_STATISTICS_EXPORTS = 'LOAD_STATISTICS_EXPORTS';
export const LOAD_STATISTICS_GROUPS = 'LOAD_ACCOUNTANCY_STATISTICS_GROUPS';
export const SET_STATISTICS_EXPORTS_PAGINATION = 'SET_STATISTICS_EXPORTS_PAGINATION';
export const EXPORT_ACCOUNTANCY_GROUPS = 'EXPORT_ACCOUNTANCY_GROUPS';
export const LOAD_ACCOUNTANCY_EXPORTS = 'LOAD_ACCOUNTANCY_EXPORTS';
export const SET_ACCOUNTANCY_EXPORTS_PAGINATION = 'SET_ACCOUNTANCY_EXPORTS_PAGINATION';
export const LOAD_ACCOUNTANCY_GROUPS = 'LOAD_ACCOUNTANCY_GROUPS';
export const LOAD_ACCOUNTANCY_INVOICE = 'LOAD_ACCOUNTANCY_INVOICE';
export const SET_ACCOUNTANCY_INVOICE_PAGINATION = 'SET_ACCOUNTANCY_INVOICE_PAGINATION';
export const LOAD_ACCOUNTANCY_INVOICE_ORDERS = 'LOAD_ACCOUNTANCY_INVOICE_ORDERS';
export const SET_ACCOUNTANCY_INVOICE_SORT = 'SET_ACCOUNTANCY_INVOICE_SORT';
export const SET_ACCOUNTANCY_INVOICE_FILTERS = 'SET_ACCOUNTANCY_INVOICE_FILTERS';
export const RESET_ACCOUNTANCY_INVOICE_FILTERS = 'RESET_ACCOUNTANCY_INVOICE_FILTERS';
export const EXPORT_INVOICES = 'EXPORT_INVOICES';
